import React from 'react'
import Button from '@mui/joy/Button'
import Modal from '@mui/joy/Modal'
import ModalClose from '@mui/joy/ModalClose'
import ModalDialog from '@mui/joy/ModalDialog'
import ModalOverflow from '@mui/joy/ModalOverflow'
import Typography from '@mui/joy/Typography'
import Stack from '@mui/joy/Stack'
import Reaptcha from 'reaptcha'
// import { yupResolver } from '@hookform/resolvers/yup'

import * as NmiForm from './NmiForm'
import { AddressFields } from './AddressFields'
import AlertWithAutoFocus from './atoms/AlertWithAutoFocus'

const modal_sx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

export default function ModalWithPaymentForm ({
  recaptchaSiteKey,
  recaptchaSiteKey_disabled,
  handleReaptchaSuccess,
  handleReaptchaErrorOrExpire,
  handleModalClose,
  control,
  register,
  submittingFinalForm,
  formError,
  onSubmit,
  modalOpen,
  collectJs_handleTimeout,
  collectJs_handleResponse,
  modalFields_email_disabled,
  setRecaptchaInstance,
  modalFields_note_show,
  required_address_fields,
}) {
  return (
    <Modal
      aria-labelledby='Donate modal'
      aria-describedby='Donate modal'
      open={modalOpen}
      onClose={handleModalClose}
      sx={modal_sx}
    >
      <ModalOverflow>
        <ModalDialog aria-labelledby='Donate modal' layout='center'>
          <ModalClose variant='plain' sx={{ m: 2 }} />

          <Typography level='h2'>Payment info</Typography>

          <Typography level='h6'>To process your credit card, please fill in the required (*) fields.</Typography>

          <Stack spacing={2}>
            <AddressFields control={control} register={register} modalFields_email_disabled={modalFields_email_disabled} modalFields_note_show={modalFields_note_show} required_address_fields={required_address_fields} />
          </Stack>

          {/* {state.modalOpen && ( */}
          <div className='d-flex justify-content-center'>
            {recaptchaSiteKey_disabled
              ? <p>Recaptcha disabled in tests</p>
              : (
                <Reaptcha
                  ref={setRecaptchaInstance}
                  sitekey={recaptchaSiteKey}
                  onVerify={handleReaptchaSuccess}
                  onExpire={handleReaptchaErrorOrExpire}
                  onError={handleReaptchaErrorOrExpire}
                />
                )}
          </div>

          <NmiForm.NmiTabs onTimeout={collectJs_handleTimeout} onResponse={collectJs_handleResponse} />

          {!submittingFinalForm &&
            formError && (
              <AlertWithAutoFocus color='danger' size='lg' variant='solid'>
                {formError}
              </AlertWithAutoFocus>
          )}

          {/* NOTE: loading is equal to disabled */}
          <Button color='primary' loading={submittingFinalForm} onClick={onSubmit}>Submit</Button>
        </ModalDialog>
      </ModalOverflow>
    </Modal>
  )
}
